const formatGuestInfoForVerifyingTripConfirmationAccess = (
  firstName,
  lastName,
  contactEmail,
  recordLocator,
) => {
  const formattedGuestInfo = {};
  if (firstName) formattedGuestInfo.firstName = firstName;
  if (lastName) formattedGuestInfo.lastName = lastName;
  if (contactEmail) formattedGuestInfo.contactEmail = contactEmail;
  if (recordLocator) formattedGuestInfo.recordLocator = recordLocator;
  return formattedGuestInfo;
};

export default formatGuestInfoForVerifyingTripConfirmationAccess;
